import { render, staticRenderFns } from "./FavoritesButton.vue?vue&type=template&id=1b57cbec"
import script from "./FavoritesButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FavoritesButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports